<template>
  <v-container>
    <v-card class="transparent" flat>
      <v-card-title>
        <h2 class="ma-auto text-center">
          Engineering Question Bank Solve Course
        </h2>
      </v-card-title>
      <v-card-text>
        <v-list class="text-center transparent">
          <v-list-item link class="segment" to="/engineering/basicclass">
            <v-list-item-content
              ><h3>Basic Class (Recorded)</h3>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link class="segment" to="/engineering/liveclasses">
            <v-list-item-content
              ><h3>Question Bank Solve Class</h3>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link class="segment" to="/engineering/exam">
            <v-list-item-content
              ><h3>Chapterwise Exam</h3>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link class="segment" to="/engineering/questionsolve">
            <v-list-item-content><h3>Exam Solve</h3> </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.segment {
  border-radius: 17px;
  background-image: linear-gradient(
    to right top,
    #21eb8a,
    #0beb78,
    #00ec65,
    #00eb4d,
    #12eb2e
  );
  margin: 10px;
  &:hover {
    transform: scale(1.01);
    border: 2px solid rgb(25, 211, 65);
  }
}
</style>